import { useOpenFrEventDetails } from '../../../../fr-event-details-page/hooks/use-open-fr-event-details';
import { FR_EVENT_DETAILS_TABS } from '../../../../fr-event-details-page/constants';
import { FrClickableCard } from '../../../../common/components/fr-clickable-card';
import { Text } from '@cad-arc';
import { BoloAssociation } from '@mark43/cad-api';
import { useOpenFrBoloDetails } from '../../../../fr-events-list-page/bolo-list/use-open-fr-bolo-details';
import { useNavigateToBoloOrEvent } from '../../../../bolos/bolo-panel/use-navigate-to-bolo-or-event';

export function BoloAssociationCard({
    boloAssociation,
    currentBoloId,
}: {
    boloAssociation: BoloAssociation;
    currentBoloId: number;
}) {
    const openFrEventDetails = useOpenFrEventDetails();
    const openFrBoloDetails = useOpenFrBoloDetails();

    const { onClickLink } = useNavigateToBoloOrEvent({
        navigateToBolo: (id) => openFrBoloDetails(id),
        navigateToEvent: (id) => openFrEventDetails(id, FR_EVENT_DETAILS_TABS.EVENT_INFO),
        currentEntityType: 'BOLO',
        currentEntityId: currentBoloId,
    });

    const { entityNumber, entityId, reason, entityType, boloId } = boloAssociation;

    const label = entityType === 'CAD_AGENCY_EVENT' ? 'Event #' : 'BOLO #';

    return (
        <FrClickableCard handleCardClick={() => onClickLink({ entityId, boloId, entityType })}>
            <Text fontWeight="semibold">
                {label}: {entityNumber}
            </Text>
            {reason && <Text style={{ marginTop: 0 }}>Comments: {reason}</Text>}
        </FrClickableCard>
    );
}
